import { EstateDesignType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { faker } from "@faker-js/faker";
import { CarBrand } from "@/domains/estate/constants/carBrand";
import { CarStatus } from "@/domains/estate/constants/carStatus";
import { EstateState } from "@/domains/estate/slice";

export const fakeResidents: EstateState["tenants"]["data"] = [
  {
    playerId: 1,
    characterId: 101,
    name: faker.person.fullName(),
    permissions: {
      garage: true,
      fridge: false,
      wardrobe: true,
      safe: false,
      upgrade: true,
    },
    fee: 500,
  },
  {
    playerId: 2,
    characterId: 102,
    name: faker.person.fullName(),
    permissions: {
      garage: false,
      fridge: true,
      wardrobe: false,
      safe: true,
      upgrade: false,
    },
    fee: 300,
  },
  {
    playerId: null,
    characterId: 103,
    name: faker.person.fullName(),
    permissions: {
      garage: true,
      fridge: true,
      wardrobe: true,
      safe: true,
      upgrade: true,
    },
    fee: 0,
  },
  {
    playerId: 3,
    characterId: 104,
    name: faker.person.fullName(),
    permissions: {
      garage: true,
      fridge: false,
      wardrobe: false,
      safe: true,
      upgrade: false,
    },
    fee: 200,
  },
  null,
  null,
  null,
];

export const fakeGarage: EstateState["vehicles"]["data"] = [
  {
    id: "1",
    brand: CarBrand.Lamborgini,
    modelName: "Huracan",
    users: [
      { id: "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d", name: "Александр Сергеевич Пушкин" },
      { id: "z9y8x7w6-v5u4-3t2s-1r0q-p9o8n7m6l5k", name: "Мария Кюри-Склодовская" },
      { id: "q1w2e3r4-t5y6-7u8i-9o0p-a1s2d3f4g5h", name: "Леонардо да Винчи" },
      { id: "k1j2h3g4-f5d6-s7a8-j9k0-l1z2x3c4v5b", name: "Фридрих Вильгельм Ницше" },
    ],
    isCommon: true,
    ownerCharacterId: "k1j2h3g4-f5d6-s7a8-j9k0-l1z2x3c4v5b",
    status: CarStatus.Broken,
    isElectric: true,
    regNumber: "К911ОТ161",
    parkingAddress: "ул. Московская 4",
    specifications: {
      acceleration: 100,
      control: 40,
      speed: 40,
    },
    improvements: {
      turbine: 1,
      engine: 3,
      brakes: 5,
    },
  },
  {
    id: "2",
    brand: CarBrand.Lamborgini,
    modelName: "Huracan",
    users: [
      { id: "n1m2b3v4-c5x6-z7q8-w9e0-r1t2y3u4i5o", name: "Амелия Эрхарт" },
      { id: "p1o2i3u4-y5t6-r7e8-w9q0-a1s2d3f4g5h", name: "Вольфганг Амадей Моцарт" },
      { id: "l1k2j3h4-g5f6-d7s8-a9h0-j1k2l3z4x5c", name: "Маргарет Тэтчер" },
      { id: "v1b2n3m4-q5w6-e7r8-t9y0-u1i2o3p4a5s", name: "Никола Тесла" },
    ],
    isCommon: false,
    ownerCharacterId: "l1k2j3h4-g5f6-d7s8-a9h0-j1k2l3z4x5c",
    status: CarStatus.IsUsed,
    isElectric: false,
    regNumber: "К911ОТ161",
    parkingAddress: "ул. Московская 4",
    specifications: {
      acceleration: 40,
      control: 40,
      speed: 100,
    },
    improvements: {
      turbine: 1,
      brakes: 5,
    },
  },

  {
    id: "3",
    brand: CarBrand.Lamborgini,
    modelName: "Huracan",
    users: [
      { id: "x1c2v3b4-n5m6-q7w8-e9r0-t1y2u3i4o5p", name: "Фёдор Михайлович Достоевский" },
      { id: "h1j2k3l4-z5x6-c7v8-b9n0-m1q2w3e4r5t", name: "Клеопатра VII Филопатор" },
    ],
    isCommon: false,
    isElectric: false,
    regNumber: "К911ОТ161",
    // addressGarage: "ул. Московская 4",
    ownerCharacterId: "1",
    specifications: {
      acceleration: 40,
      control: 40,
      speed: 100,
    },
  },
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
];

export const fakeMail: EstateState["mail"]["data"] = [
  {
    id: "1",
    avatarSrc: null,
    subject: "Meeting Reminder",
    from: "john@example.com",
    to: "jane@example.com",
    date: "2023-10-01T10:00:00Z",
    isRead: true,
  },
  {
    id: "2",
    avatarSrc: null,
    subject: "Welcome to our service",
    from: "noreply@example.com",
    to: "user@example.com",
    date: new Date(),
    isRead: false,
  },
  {
    id: "3",
    avatarSrc: null,
    subject: "Invitation to collaborate",
    from: "team@example.com",
    to: "user@example.com",
    date: "2023-10-03T09:00:00Z",
    isRead: true,
  },
  {
    id: "4",
    avatarSrc: null,
    subject: "Payment received",
    from: "billing@example.com",
    to: "client@example.com",
    date: "2023-10-04T12:45:00Z",
    isRead: true,
  },
  {
    id: "5",
    avatarSrc: null,
    subject: "Your subscription is expiring",
    from: "support@example.com",
    to: "user@example.com",
    date: "2023-10-05T08:00:00Z",
    isRead: false,
  },
  {
    id: "6",
    avatarSrc: null,
    subject: "New product launch",
    from: "marketing@example.com",
    to: "user@example.com",
    date: "2023-10-06T14:30:00Z",
    isRead: false,
  },
  {
    id: "7",
    avatarSrc: null,
    subject: "Lunch tomorrow?",
    from: "jane@example.com",
    to: "john@example.com",
    date: "2023-10-07T12:00:00Z",
    isRead: true,
  },
  {
    id: "8",
    avatarSrc: null,
    subject: "Feedback request",
    from: "feedback@example.com",
    to: "user@example.com",
    date: "2023-10-08T16:00:00Z",
    isRead: false,
  },
  {
    id: "9",
    avatarSrc: null,
    subject: "Your ticket has been resolved",
    from: "support@example.com",
    to: "user@example.com",
    date: "2023-10-09T09:15:00Z",
    isRead: true,
  },
  {
    id: "10",
    avatarSrc: null,
    subject: "Weekly newsletter",
    from: "newsletter@example.com",
    to: "user@example.com",
    date: "2023-10-10T07:00:00Z",
    isRead: false,
  },
  {
    id: "11",
    avatarSrc: null,
    subject: "Company update",
    from: "ceo@example.com",
    to: "all@example.com",
    date: "2023-10-11T18:00:00Z",
    isRead: true,
  },
  {
    id: "12",
    avatarSrc: null,
    subject: "Password reset request",
    from: "security@example.com",
    to: "user@example.com",
    date: "2023-10-12T10:30:00Z",
    isRead: false,
  },
  {
    id: "13",
    avatarSrc: null,
    subject: "Invitation to our webinar",
    from: "events@example.com",
    to: "user@example.com",
    date: "2023-10-13T11:00:00Z",
    isRead: false,
  },
  {
    id: "14",
    avatarSrc: null,
    subject: "Thank you for your purchase",
    from: "orders@example.com",
    to: "customer@example.com",
    date: "2023-10-14T13:20:00Z",
    isRead: true,
  },
  {
    id: "15",
    avatarSrc: null,
    subject: "Interview schedule",
    from: "hr@example.com",
    to: "candidate@example.com",
    date: "2023-10-15T15:00:00Z",
    isRead: false,
  },
];

export const fakeMessages: EstateState["mail"]["messages"] = [
  {
    messageId: "1",
    userId: "1",
    avatarSrc: null,
    from: "John Doe",
    message: "Привет! Как дела?",
    date: "2023-10-01T10:00:00Z",
    isRead: true,
  },
  {
    messageId: "2",
    userId: "2",
    avatarSrc: null,
    from: "Jane Smith",
    message: "Привет! Все отлично, спасибо!",
    date: "2023-10-01T10:05:00Z",
    isRead: true,
  },
  {
    messageId: "3",
    userId: "1",
    avatarSrc: null,
    from: "Alice Johnson",
    message: "Что нового?",
    date: "2023-10-01T10:10:00Z",
    isRead: false,
  },
  {
    messageId: "4",
    userId: "2",
    avatarSrc: null,
    from: "Bob Brown",
    message: "Давай встретимся завтра.",
    date: "2023-10-01T10:15:00Z",
    isRead: true,
  },
  {
    messageId: "5",
    userId: "1",
    avatarSrc: null,
    from: "Charlie Davis",
    message: "Отправь мне файл, пожалуйста.",
    date: "2023-10-01T10:20:00Z",
    isRead: false,
  },
  {
    messageId: "6",
    userId: "2",
    avatarSrc: null,
    from: "Eve White",
    message: "Я уже отправила.",
    date: "2023-10-01T10:25:00Z",
    isRead: true,
  },
  {
    messageId: "7",
    userId: "1",
    avatarSrc: null,
    from: "Frank Wilson",
    message: "Спасибо!",
    date: "2023-10-01T10:30:00Z",
    isRead: false,
  },
  {
    messageId: "8",
    userId: "2",
    avatarSrc: null,
    from: "Grace Lee",
    message: "Когда будет презентация?",
    date: "2023-10-01T10:35:00Z",
    isRead: true,
  },
  {
    messageId: "9",
    userId: "1",
    avatarSrc: null,
    from: "Hank Green",
    message: "Завтра в 10 утра.",
    date: "2023-10-01T10:40:00Z",
    isRead: false,
  },
  {
    messageId: "10",
    userId: "2",
    avatarSrc: null,
    from: "Ivy Hall",
    message: "Хорошо, спасибо!",
    date: "2023-10-01T10:45:00Z",
    isRead: true,
  },
];

export const fakeRepair: EstateState["repair"]["data"] = [
  {
    id: "1",
    name: "Планировка #1",
    description:
      "Отличительная черта перепланировки вашего особняка, исключительно для вас, вы будете первым парнем на деревне",
    cost: 3500,
    imgs: [null, null, null],
  },
  {
    id: "2",
    name: "Планировка #2",
    description:
      "Отличительная черта перепланировки вашего особняка, исключительно для вас, вы будете первым парнем на деревне",
    cost: 4500,
    imgs: [null, null, null],
  },
  {
    id: "3",
    name: "Планировка #3",
    description:
      "Отличительная черта перепланировки вашего особняка, исключительно для вас, вы будете первым парнем на деревне",
    cost: 1500,
    imgs: [null, null, null],
  },
  {
    id: "4",
    name: "Планировка #4",
    description:
      "Отличительная черта перепланировки вашего особняка, исключительно для вас, вы будете первым парнем на деревне",
    cost: 5500,
    imgs: [null, null, null],
  },
  {
    id: "5",
    name: "Планировка #5",
    description:
      "Отличительная черта перепланировки вашего особняка, исключительно для вас, вы будете первым парнем на деревне",
    cost: 1500,
    imgs: [null, null, null],
  },
  {
    id: "6",
    name: "Планировка #6",
    description:
      "Отличительная черта перепланировки вашего особняка, исключительно для вас, вы будете первым парнем на деревне",
    cost: 35200,
    imgs: [null, null, null],
  },
  {
    id: "7",
    name: "Планировка #7",
    description:
      "Отличительная черта перепланировки вашего особняка, исключительно для вас, вы будете первым парнем на деревне",
    cost: 500,
    imgs: [null, null, null],
  },
];

export const fakeDesign: EstateState["design"]["designVariants"] = [
  {
    interiorPropId: 101,
    isActive: true,
    uuid: "a1b2c3d4-e5f6-7890-g1h2-i3j4k5l6m7n8",
    price: 2499,
    type: EstateDesignType.Wall,
    name: "Modern Brick Wall",
    images: [
      "https://cs14.pikabu.ru/post_img/big/2024/01/22/9/1705934889144931564.png",
      "https://cs14.pikabu.ru/post_img/big/2024/01/22/9/1705934889144931564.png",
    ],
  },
  {
    interiorPropId: 205,
    isActive: true,
    uuid: "b2c3d4e5-f6g7-8901-h2i3-j4k5l6m7n8o9",
    price: 3599,
    type: EstateDesignType.Furniture,
    name: "Luxury Leather Sofa",
    images: [
      "https://cs14.pikabu.ru/post_img/big/2024/01/22/9/1705934889144931564.png",
      "https://cs14.pikabu.ru/post_img/big/2024/01/22/9/1705934889144931564.png",
    ],
  },
  {
    interiorPropId: 178,
    isActive: false,
    uuid: "c3d4e5f6-g7h8-9012-i3j4-k5l6m7n8o9p0",
    price: 1299,
    type: EstateDesignType.Wall,
    name: null, // Намеренно null для демонстрации
    images: ["https://cs14.pikabu.ru/post_img/big/2024/01/22/9/1705934889144931564.png"],
  },
];
